import { getKeys } from '@shared/utils/object';
import { createContext, useContext } from 'react';
import type { FormControlContextType, FormControlBaseProps } from './FormControl.types';

export const FormControlContext = createContext<FormControlContextType | undefined>(undefined);

export const useFormControlContext = () => {
  return useContext(FormControlContext);
};

export const useFormControl = <P extends FormControlBaseProps>(props: P): FormControlBaseProps => {
  const context = useFormControlContext();
  if (!context) {
    return props;
  }

  return getKeys(context).reduce((acc, prop) => {
    // Give precedence to children component props
    acc[prop] = typeof props[prop] !== 'undefined' ? props[prop] : context[prop];
    return acc;
  }, {} as UnsealedReadonly<FormControlBaseProps>);
};

/**
 * Turns on live announcements of field errors for the FormControls inside it (see FormControl). Off
 * by default: a form opts in once it has checked its own submit flow against the rules FormControl
 * follows, because a form that keeps focus in a field on submit has to announce that field's error
 * itself.
 */
export const FieldErrorAnnouncementContext = createContext(false);
export const FieldErrorAnnouncementProvider = FieldErrorAnnouncementContext.Provider;
